import type { BannerBlockDoc as BannerBlockType } from "../../types/blocks";
import RichText from "../../RichText";
import { cn } from "@onclicks/sharedcomponents/ui";
import React from "react";

export const BannerBlock: React.FC<
  {
    className: string;
  } & BannerBlockType
> = (props) => {
  const { style, content, className } = props;

  return (
    <div className={cn("mx-auto my-8 w-full", className)}>
      <div
        className={cn("border py-3 px-6 flex items-center rounded", {
          "border-border bg-card": style === "info",
          "border-error bg-error/30": style === "error",
          "border-success bg-success/30": style === "success",
          "border-warning bg-warning/30": style === "warning",
        })}
      >
        <RichText data={content} enableGutter={false} enableProse={false} />
      </div>
    </div>
  );
};
